import client, { response } from './client'
import * as httpClient from 'http-otro'

export function me(){
  return client.get(`sessions/me`).then((res)=>{
    if(res.status != 403) return res.json()
    return {}
  })
}

export function config(){
  return client.get(`/setup`).then((res)=>{
    if(res.status != 403) return res.json()
    return {}
  })
}

export function login(email, password){
  return client.post('sessions/login', {email, password}).then((res)=>{
    if(res.status == 200){
      return updateToken(res);
    }
  });
}

export function getPlans(){
  return client.get('plans').then((res)=>{
    return res.json();
  })
}

export function setAuthToken(token){
  localStorage.setItem('token', token);
}

function updateToken(res){
  let token = res.headers.get('authorization');
  if(token){
    setAuthToken(token);
  }

  return res.json()
}

export function logout(){
  localStorage.removeItem('token');
  localStorage.removeItem('account_id');
  location.href = "/";
}

export function uploadFile(base64, file){
  return client.post('uploads', base64, {headers: {'Content-Type': 'application/octet-stream', 'X-File-Name': file.name, 'X-File-Type': file.type}});
}

export function uploadRemoteFile(fileURL, extType) {
  return client.post('uploads/remote', {fileUrl: fileURL, ext: extType})
}

export function cancelAccount(){
  return new Promise((resolve, reject)=>{
    client.get('cancel').then((res)=>{
      if(res.status == 200){
        resolve();
      } else {
        reject();
      }
    });
  });
}

export function inviteUser (email) {
  return response.json(client.post('invites', {email: email}))
}

export function addUserToAccount (token) {
  return response.json(client.post('invites/verify', { token }))
}

/** 'coupons' api calls **/

export function getCoupons () {
  return response.json(client.get('coupons'));
}

export function createCoupon (payload) {
  return response.json(client.post('coupons', payload))
}

export function updateCoupon (id, payload) {
  return response.json(client.put(`coupons/${id}`, payload))
}

export function deleteCoupon (id) {
  return response.json(client.del(`coupons/${id}`))
}

export function deliverCoupon (id, email) {
  return response.json(client.post('coupons/deliver', {id, email}))
}

export function getActiveCoupon (token) {
  return response.json(client.get('coupons/active', {token}))
}

/** 'preferences' api calls **/

export function updatePreferences(userId, payload) {
  return response.json(client.put(`preferences/${userId}`, payload))
}

export function getPreferences () {
  return response.json(client.get(`preferences`))
}

/** 'users' api calls **/

export function fetchAllUsers() {
  return response.json(client.get('users'))
}

export function createFavorites(format_id) {
  return response.json(client.post('favorites', { format_id }))
}

export function deleteFavorites(id) {
  return response.json(client.del(`favorites/${id}`))
}

export function loadFavorites() {
  return response.json(client.get('favorites'))
}

export function signup(email, password, name){
  /* Hubspot Lead Form */
  let data = {
    'submittedAt': (new Date()).getTime().toString(),
    'fields': [
      {
        'objectTypeId': '0-1',
        'name': 'email',
        'value': email
      },
      {
        'objectTypeId': '0-1',
        'name': 'first_and_last_name',
        'value': name
      }
    ]
  }
  //"0-2/domain"
  try {
    httpClient.client({host: 'https://api.hsforms.com', headers: {contentType: 'application/json'}}).post('/submissions/v3/integration/submit/2898305/4ba490b5-a6f7-48e3-ad37-041c23b70944', data)
  } catch (e) {
    console.log(e);
  }
  return response.json(client.post('users', {email, password, name}));
}

export async function signupHubspotNotification (email, name) {
  /* Hubspot Lead Form */
  let data = {
    'submittedAt': (new Date()).getTime().toString(),
    'fields': [
      {
        'objectTypeId': '0-1',
        'name': 'email',
        'value': email
      },
      {
        'objectTypeId': '0-1',
        'name': 'first_and_last_name',
        'value': name
      }
    ]
  }
  //"0-2/domain"
  try {
    await httpClient.client({host: 'https://api.hsforms.com', headers: {contentType: 'application/json'}}).post('/submissions/v3/integration/submit/2898305/4ba490b5-a6f7-48e3-ad37-041c23b70944', data)
  } catch (e) {
    console.log(e);
  }
  return true;
}

export function emailAvailable(email){
  return response.json(client.get('users/email_check', {email}));
}

export function updateBasicDetails(userId, payload){
  return client.put(`users/update`, payload).then((res)=>{
    if (res.ok) {
      return updateToken(res);
    } else {
      return res
    }
  }).then((json)=>{
    return json;
  });
}

export function updateUser(userId, payload) {
  return client.put(`users/${userId}`, payload);
}

export function updatePassword({userId, currentPassword, newPassword, hasPassword}){
  return new Promise((resolve, reject)=>{
    if(!hasPassword){
      client.put(`users/update`, {password: newPassword}).then((res)=>{
        return updateToken(res);
      }).then(resolve).catch(reject);
    } else {
      client.post('users/new_password_verification', {password: currentPassword}).then((res)=>{
        if(res.status == 200){
          client.put(`users/update`, {password: newPassword}).then((res)=>{
            return updateToken(res);
          }).then(resolve).catch(reject);
        } else {
          reject();
        }
      });
    }
  });
}

export function sendForgotPassword(email){
  return response.json(client.post('users/password_token', {email}));
}

export function verifyPassword(token){
  return client.post('users/verify_password', {token}).then((res)=>{
    if(res.status == 200){
      return updateToken(res);
    }
  });
}

export function verifySignUp (token) {
  return client.post('users/verify', {token}).then((res) => {
    if (res.status == 200) {
      return updateToken(res);
    } else {
      delete localStorage.signup_token
      return res.json();
    }
  })
}

/** 'account_users' api calls **/

export function removeUserFromAccount (id) {
  return response.json(client.del(`account_users/${id}`))
}

export function toggleUserPermissions (id, permissions) {
  return response.json(client.put(`account_users/${id}`, {permissions: permissions}))
}

/** 'account_formats' api calls **/

export function createAccountFormat (format_id, account_id) {
  return response.json(client.post('account_formats', { format_id, account_id }))
}

export function deleteAccountFormat (id) {
  return response.json(client.del(`account_formats/${id}`))
}

/** 'account_selected_formats' api calls **/

export function createAccountSelectedFormat (format_id) {
  return response.json(client.post('account_selected_formats', {format_id}))
}

export function deleteAccountSelectedFormat (id) {
  return response.json(client.del(`account_selected_formats/${id}`));
}

/** 'category_formats' api calls **/

export function getCategoryFormats() {
  return response.json(client.get('category_formats'));
}

export function deleteFormatFromCategory(id) {
  return response.json(client.del(`category_formats/${id}`));
}

export function addFormatToCategory(payload) {
  return response.json(client.post('category_formats', payload))
}

/** 'formats' api calls **/

export function getPreview(formatId, input){
  return client.post(`formats/${formatId}/preview`, input);
}

export function getFormats(){
  return response.json(client.get('formats'));
}

export function updateFormat(id, payload) {
  return response.json(client.put(`formats/${id}`, payload))
}

export function getAllFormats() {
  return response.json(client.get('formats/all'));
}

export function getSelectedFormats() {
  return response.json(client.get('formats/selected'));
}

export function deleteFormat(id) {
  return response.json(client.del(`formats/${id}`));
}

export function updateSortFormats(format_ids) {
  return response.json(client.put(`formats/update_sort`, {format_ids}))
}

/** 'categories' api calls **/

export function getCategories(){
  return response.json(client.get('categories'));
}

export function createCategory(payload){
  return response.json(client.post('categories', payload));
}

export function updateCategory(id, category){
  return response.json(client.put(`categories/${id}`, category));
}

export function deleteCategory(id) {
  return response.json(client.del(`categories/${id}`));
}

/** 'advertisements' api calls **/

export function getAds(){
  const params = {};
  let m;
  if (m = location.href.match(/share_code=(.+)/)) { // \w+
    params.share_code = m[1];
  }
  return response.json(client.get('advertisements', params));
}

export function createAd(payload){
  return response.json(client.post('advertisements', payload));
}

export function updateAd(id, ad){
  return response.json(client.put(`advertisements/${id}`, ad));
}

export function copyAd(id){
  return response.json(client.get(`advertisements/${id}/copy`, { id }));
}

export function deleteAd(id){
  return response.json(client.del(`advertisements/${id}`));
}

export function shareAd (email, url) {
  return client.post('advertisements/share', {email, url})
}

export function regenerateAdvertisementsCode(formatId){
  return response.json(client.put(`advertisements/${formatId}/regenerate`))
}

export function loadSingleAd (id) {
  return response.json(client.get(`advertisements/${id}`))
}

/** 'account' api calls **/

export function getCustomFormats(id) {
  return response.json(client.get(`accounts/${id}/formats`, {id}))
}

export function createAccount (name) {
  return response.json(client.post('accounts', { name }))
}

export function issueRefund(accountId, chargeId) {
  return response.json(client.put(`/accounts/${accountId}/refund`, {account_id: accountId, charge_id: chargeId}))
}

export function getCharges(accountId) {
  return response.json(client.get(`accounts/${accountId}/charges`, {id: accountId}))
}

export function saveAccountInfo({ account }) {
  return response.json(client.put(`accounts/${account.id}`, account));
}

export function getAccounts(){
  return response.json(client.get('accounts'));
}

export function getAllAccounts() {
  return response.json(client.get('accounts/all'));
}

export function deleteAccount (accountId) {
  return response.json(client.del(`accounts/${accountId}`))
}

export function getUpdateRuleFields () {
  return response.json(client.get(`update_rules/fields`))
}

export function updateUpdateRule (id, payload) {
  return response.json(client.put(`update_rules/${id}`, payload))
}

export function createUpdateRule (payload) {
  return response.json(client.post(`update_rules`, payload))
}

export function getUpdateRule (id) {
  return response.json(client.get(`update_rules/${id}`))
}

export function getUpdateFields() {
  return response.json(client.get(`updates/fields`))
}

export function createUpdate(payload) {
  return response.json(client.post(`updates`, payload))
}

export function confirmUpdate (token) {
  return response.json(client.post(`updates/confirm`, {token}))
}

export function approveUpdate (token) {
  return response.json(client.post(`updates/approve`, {token}))
}

export function denyUpdate (token) {
  return response.json(client.del(`updates/deny`, {token}))
}

export function getScheduled (id) {
  return response.json(client.get(`updates/scheduled`, {advertisement_id: id}))
}

export function loadUpdateRuleLimited (id) {
  return response.json(client.get(`update_rules/limited`, {id: id}))
}

export function createReferral (email) {
  return response.json(client.post(`referrals`, {email}))
}

export function confirmReferral (token) {
  return response.json(client.post(`referrals/confirm`, {token}))
}



// WEBPACK FOOTER //
// ./src/lib/api/calls.js